module.exports = __webpack_public_path__ + "img/img69.e85d8131.png";